import Vue from 'vue'
import Wysiwyg from 'vue-wysiwyg'

Vue.use(Wysiwyg, {})
